import { useTranslation } from "react-i18next";
import { Typography } from "@material-ui/core";
import SectionHeader from "components/SectionHeader";
import DashboardSecuritySettings from "./DashboardSecuritySettings";
import MxheroAppSecuritySettings from "./MxheroAppSecuritySettings";

export default function OrganizationSecurity() {
  const { t } = useTranslation("security");

  return (
    <>
      <SectionHeader title={t("sectionTitle")}>
        <Typography>{t("sectionExplanation")}</Typography>
      </SectionHeader>
      <DashboardSecuritySettings />
      <MxheroAppSecuritySettings />
    </>
  );
}
